export class DeclinedOperationQueryParameters {
  action?: string;
  actionDateFrom?: string;
  actionId?: string;
  actionDateTo?: string;
  associateId?: string;
  dateOpenedFrom?: Date;
  dateOpenedTo?: Date;
  messagePreferenceId?: string;
  page?: number;
  pageSize?: number;
  reason?: string;
  search?: string;
  serviceAdvisorId?: string;
  serviceGroupCategory?: string;
  serviceGroupSubCategory?: string;
  sort?: string;
  stated?: string;
  vehicleId?: string;
  vehicleYearFrom?: number;
  vehicleYearTo?: number;
  vin?: string;
  workOrderId?: string;

  [key: string]: string | number | Date;

  constructor(obj?: DeclinedOperationQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
